import { EXTREME_IMAGES, IMAGE_COUNT } from "../../assets/const";

// Modern och säker shuffle (returnerar en ny array istället för att mutera)
const shuffle = (array) => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
};

export const getShuffledBoard = (extreme) => {
    // Skapa array [0, 1, ..., IMAGE_COUNT-1]
    const allItems = Array.from({ length: IMAGE_COUNT }, (_, i) => i);
    const shuffled = shuffle(allItems);
    const board = shuffled.slice(0, 25);

    if (extreme) {
        const extremeImages = shuffle(EXTREME_IMAGES);
        // Placera ut i "stjärnmönster" eller rader baserat på din tidigare logik
        for (let i = 0; i < 5; i++) {
            board[i * 6] = extremeImages[i];
        }
    }

    return board;
};

export const indexToRowCol = (index) => ({
    row: Math.floor(index / 5),
    col: index % 5
});

export const checkForBingo = (checkedBlocks, index) => {
    // Skapa en tom array med 25 nollor
    const bingoArray = new Array(25).fill(0);
    
    if (!checkedBlocks[index]) return bingoArray;

    const { row, col } = indexToRowCol(index);
    
    // Definiera grupper att kontrollera
    const groups = [
        Array.from({ length: 5 }, (_, i) => row * 5 + i), // Horisontell
        Array.from({ length: 5 }, (_, i) => i * 5 + col), // Vertikal
    ];

    // Diagonaler
    if (row === col) groups.push([0, 6, 12, 18, 24]);
    if (row + col === 4) groups.push([20, 16, 12, 8, 4]);

    // Kontrollera varje grupp
    groups.forEach((group, groupIndex) => {
        if (group.every(idx => checkedBlocks[idx])) {
            group.forEach((idx, pos) => {
                bingoArray[idx] = pos + 1; // Markera vinstsekvensen
            });
        }
    });

    return bingoArray;
};